import React, { useEffect, useState } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

import { getVoipRecording } from 'services/voip.services';

const RecordingAudioPlayer = ({ recordingUrl, autoPlay = false, compact = false }) => {
  const [audioUrl, setAudioUrl] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let objectUrl = '';
    let isMounted = true;

    if (!recordingUrl) {
      setAudioUrl('');
      return undefined;
    }

    if (/^https?:\/\//i.test(recordingUrl)) {
      setAudioUrl(recordingUrl);
      return undefined;
    }

    setLoading(true);
    setError('');
    getVoipRecording(recordingUrl)
      .then((response) => {
        if (!isMounted) return;
        const contentType = response?.headers?.['content-type'] || 'audio/wav';
        objectUrl = window.URL.createObjectURL(new Blob([response?.data], { type: contentType }));
        setAudioUrl(objectUrl);
      })
      .catch((err) => {
        if (!isMounted) return;
        setError(err?.message || 'Không tải được file ghi âm');
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [recordingUrl]);

  if (loading) {
    return <div style={{ color: '#64748b', fontSize: 13, padding: compact ? '4px 0' : '12px 0' }}>Đang tải ghi âm...</div>;
  }

  if (error) {
    return <div style={{ color: '#dc2626', fontSize: 13, padding: compact ? '4px 0' : '12px 0' }}>{error}</div>;
  }

  if (!audioUrl) return null;

  return (
    <AudioPlayer
      autoPlay={autoPlay}
      src={audioUrl}
      style={compact ? { marginTop: 5 } : undefined}
    />
  );
};

export default RecordingAudioPlayer;
